import { useTranslation } from "next-i18next";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const LetsMeet = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        gap: "10px",
      }}
    >
      <Typography component="h2" variant="subtitle">
        {t("footer.lets_meet")}
      </Typography>
      <Typography variant="code1">Kraków, Poland</Typography>
      <Typography variant="code1">Wrocław, Poland</Typography>
      <Typography variant="code1">Warszawa, Poland</Typography>
    </Box>
  );
};
